// Nuevo módulo en Angular para instanciar los componentes que tiene el módulo de bajas.
// Se importa en app.module.ts

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule } from "@angular/router";
import { SharedModule } from "../../../shared/shared.module";
import { BajasComponent } from "./bajas.component";
import {
    BajasFormComponent,
    RechazarBajasComponent,
    ValidarBajasComponent,
} from "./bajas-form.component";
import { BajasConfirmDeleteComponent } from "./bajas-confirm-delete.component";

@NgModule({
    declarations: [
        BajasComponent,
        BajasFormComponent,
        ValidarBajasComponent,
        RechazarBajasComponent,
        BajasConfirmDeleteComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatTableModule,
        MatTabsModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatDividerModule,
        MatDatepickerModule,
        MatDialogModule,
        MatCardModule,
        SharedModule,
    ],
    providers: []
})
export class BajasModule { }
